"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_confetti_1 = __importDefault(require("react-confetti"));
const components_1 = require("components");
const config_1 = require("config");
const utils_1 = require("utils");
function ImprintCashFlowApproved({ increasedAmount, handleViewOffer, }) {
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(react_confetti_1.default, { numberOfPieces: 25, initialVelocityY: 2, recycle: true, style: { zIndex: 100000000 }, colors: [
                    config_1.BRAND_COLOR.RED,
                    config_1.BRAND_COLOR.ORANGE,
                    config_1.BRAND_COLOR.PURPLE,
                    config_1.BRAND_COLOR.NAVY,
                    config_1.BRAND_COLOR.GREEN,
                ] }), (0, jsx_runtime_1.jsx)(components_1.H1, { children: "You're Pre-qualified for a Higher Loan Amount!" }), (0, jsx_runtime_1.jsxs)(components_1.P, { variant: "title-large", className: "mar-t-32", children: ["Congratulations! You\u2019re now pre-qualified for a loan of", ' ', (0, utils_1.formatCurrency)(increasedAmount), "\u2014an increase from your original offer."] }), (0, jsx_runtime_1.jsx)(components_1.Button, { type: "button", className: "button-warn-advantage mar-t-32", onClick: handleViewOffer, children: "VIEW OFFER" })] }));
}
exports.default = ImprintCashFlowApproved;
